import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const Container = styled(Box)`
  width: 100%;
  height: 100%;
  overflow-y: hidden;

  /* The header comes from the shared HeaderComponent Wrapper, whose borderLow
     border is a dark-only literal. Scope the light treatment from here. */
  html[data-theme='light'] & {
    .header-container {
      background: ${theme.colors.surfaceContainerBackground};
      border-bottom-color: ${theme.colors.strokePrimary};
    }
  }
`

export const Content = styled(Box)<{ isFiltersOpen?: string }>`
  display: flex;
  justify-content: center;
  height: calc(100vh - 100px);
  overflow-y: hidden;
  padding-bottom: ${theme.spacing.xLarge}px;
  width: 100%;
  flex-basis: 100%;
  transition: all 0.2s ease-in-out;

  ${({ isFiltersOpen }) =>
    isFiltersOpen &&
    isFiltersOpen === 'true' &&
    `
      height: calc(100vh - 188px);
    `};

  .insights-list-wrapper {
    width: 100%;
    flex-basis: 50%;
    padding: ${theme.spacing.small}px ${theme.spacing.medium}px 0;

    ::-webkit-scrollbar {
      width: 4px;
      background: transparent;
    }

    ::-webkit-scrollbar-track {
      box-shadow: none;
      background: ${theme.colors.strokePrimary};
    }

    ::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.cta};
      border-radius: ${theme.attributes.borderRadius.quaternary};
    }
  }
`

export const NoResultsWrapper = styled(Box)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: ${theme.spacing.large}px;

  .no-results-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${theme.spacing.xSmall}px;

    .no-results-header {
      color: ${theme.colors.foreground};
      font-size: ${theme.typography.fontSize.xxxLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: normal;
    }

    .no-results-text {
      color: ${theme.colors.textSecondary};
      text-align: center;
      font-size: ${theme.typography.fontSize.xLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: normal;
    }
  }

  .svg-wrapper {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 1;
  }
`

export const dateRangePickerPopperSx = {
  '.MuiPaper-root': {
    position: 'absolute',

    display: 'flex',
    background: 'transparent',

    '.MuiPickersToolbar-root': {
      display: 'none'
    },
    '.MuiPickersLayout-root': {
      borderRadius: theme.attributes.borderRadius.mediumSmall,
      background: theme.colors.tooltipBg,
      display: 'flex',
      flexDirection: 'column',

      '.MuiPickersCalendarHeader-root': {
        '.MuiPickersCalendarHeader-labelContainer': {
          '.MuiPickersCalendarHeader-label': {
            color: theme.colors.devicesSecondaryText,
            textAlign: 'center',
            fontFamily: theme.typography.fontFamily.primary,
            fontSize: theme.typography.fontSize.large,
            fontStyle: 'normal',
            fontWeight: theme.typography.fontWeight.bold,
            lineHeight: '20px',
            letterSpacing: '0.1px'
          }
        },

        '.MuiPickersArrowSwitcher-root': {
          '.MuiButtonBase-root': {
            color: theme.colors.devicesSecondaryText,

            '&.Mui-disabled': {
              opacity: 0.26
            }
          }
        }
      },

      '.MuiDayCalendar-root': {
        '.MuiDayCalendar-header': {
          '.MuiTypography-root': {
            color: theme.colors.menuItemText,
            textAlign: 'center',
            fontFamily: theme.typography.fontFamily.primary,
            fontSize: theme.typography.fontSize.medium,
            fontStyle: 'normal',
            fontWeight: theme.typography.fontWeight.bold,
            lineHeight: '16px',
            letterSpacing: '0.5px'
          }
        },

        '.MuiDayCalendar-monthContainer': {
          '.MuiDayCalendar-weekContainer': {
            '.MuiDateRangePickerDay-hiddenDayFiller': {
              background: 'transparent !important'
            }
          },

          '.MuiDateRangePickerDay-root': {
            '.MuiButtonBase-root': {
              color: theme.colors.menuItemText,
              textAlign: 'center',
              fontFamily: theme.typography.fontFamily.primary,
              fontSize: theme.typography.fontSize.large,
              fontStyle: 'normal',
              fontWeight: theme.typography.fontWeight.normal,
              lineHeight: '20px',
              letterSpacing: '0.25px',

              '&.Mui-selected': {
                borderRadius: theme.attributes.borderRadius.circle,
                color: theme.colors.analyzerIconActive,
                background: theme.colors.cta
              },

              '&.Mui-disabled': {
                color: theme.colors.devicesSecondaryText,
                opacity: 0.38
              }
            },

            '&.MuiDateRangePickerDay-root.MuiDateRangePickerDay-rangeIntervalDayHighlight': {
              background: theme.colors.legacy6a5371
            }
          }
        }
      },

      '.MuiDialogActions-root': {
        '.MuiButton-root': {
          color: theme.colors.cta,
          textAlign: 'center',
          fontFamily: theme.typography.fontFamily.primary,
          fontSize: theme.typography.fontSize.large,
          fontStyle: 'normal',
          fontWeight: theme.typography.fontWeight.bold,
          lineHeight: '20px',
          letterSpacing: '0.1px',

          '&:first-of-type': {
            textTransform: 'capitalize'
          }
        }
      }
    }
  }
}
